import {DateTimePicker, LocalizationProvider} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {Button, CardHeader, Grid, Paper, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";

class RubyBattleWrapped extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        const now = new Date();
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);

        this.state = {
            loading: false,
            filter: {
                startTime: yesterday,
                endTime: now,
            },
            content: {
                totalMatch: 0,
                totalFee: 0,
                currentMatching: 0,
                currentBattle: 0,
                matchingUsers: [],
            }
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        const url = `${Config.getInstance.apiUrl}/api/report/ruby_battle`;

        this.setState({
            loading: true,
        });

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        try {
            const response = await axios.get(url, {
                params: {
                    startTime: this.state.filter.startTime,
                    endTime: this.state.filter.endTime,
                },
                headers
            });

            const data = response.data;

            if (data.success) {
                this.setState({
                    content: {
                        totalMatch: data.totalMatch || 0,
                        totalFee: data.totalFee || 0,
                        currentMatching: data.currentMatching || 0,
                        currentBattle: data.currentBattle || 0,
                        matchingUsers: data.matchingUsers || [],
                    }
                });
            } else {
                PopupMessage.error(data.message || "Failed to fetch data");
            }
        } catch (e) {
            PopupMessage.error("Failed to fetch data");
        } finally {
            this.setState({
                loading: false,
            });
        }

    }

    handleChangeTime = (key: string, value: any) => {
        const filter = this.state.filter;
        filter[key] = value;
        this.setState({
            filter
        });
    }

    renderFilter() {
        const filter = this.state.filter;
        return <Paper>
            <Grid container sm={12} rowSpacing={2}>
                <Grid item container sm={12}>
                    <Grid item container sm={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateTimePicker
                                label="Start Time"
                                value={filter.startTime}
                                onChange={(e) => this.handleChangeTime("startTime", e)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                            />
                        </LocalizationProvider>
                    </Grid>

                </Grid>

                <Grid item container sm={12}>
                    <Grid item sm={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateTimePicker
                                label="End Time"
                                value={filter.endTime}
                                onChange={(e) => this.handleChangeTime("endTime", e)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>

                <Grid item container sm={12} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <Button
                            color="primary"
                            onClick={this.fetchData.bind(this)}
                            variant="contained"
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    renderContent() {
        const {classes} = this.props;
        const content = this.state.content;

        return <Grid container spacing={3}>
            <Grid item xs={4}>
                <Paper className="stats-root" elevation={0}>
                    <div style={{float: "left", padding: "15px 22px 15px 22px", width: "100%"}}>
                        <div className={classes.title}>
                            <Typography variant="h6" style={{textAlign: "center"}}>
                                Total Match
                            </Typography>

                            <Typography variant="h2" style={{textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center"}}>
                                {!this.state.loading ? Helpers.formatNumber(content.totalMatch) : <Skeleton width={150} />}
                            </Typography>
                        </div>
                    </div>
                </Paper>
            </Grid>

            <Grid item xs={4}>
                <Paper className="stats-root" elevation={0}>
                    <div style={{float: "left", padding: "15px 22px 15px 22px", width: "100%"}}>
                        <div className={classes.title}>
                            <Typography variant="h6" style={{textAlign: "center"}}>
                                Total Fee
                            </Typography>

                            <Typography variant="h2" style={{textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center"}}>
                                {!this.state.loading ? Helpers.formatNumber(content.totalFee) : <Skeleton width={150} />}
                            </Typography>
                        </div>
                    </div>
                </Paper>
            </Grid>

            <Grid item xs={4}>
                <Paper className="stats-root" elevation={0}>
                    <div style={{float: "left", padding: "15px 22px 15px 22px", width: "100%"}}>
                        <div className={classes.title}>
                            <Typography variant="h6" style={{textAlign: "center"}}>
                                Current Matching
                            </Typography>

                            <Typography variant="h2" style={{textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center"}}>
                                {!this.state.loading ? Helpers.formatNumber(content.currentMatching) : <Skeleton width={150} />}
                            </Typography>
                        </div>
                    </div>
                </Paper>
            </Grid>

            <Grid item xs={4}>
                <Paper className="stats-root" elevation={0}>
                    <div style={{float: "left", padding: "15px 22px 15px 22px", width: "100%"}}>
                        <div className={classes.title}>
                            <Typography variant="h6" style={{textAlign: "center"}}>
                                Battling Player
                            </Typography>

                            <Typography variant="h2" style={{textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center"}}>
                                {!this.state.loading ? Helpers.formatNumber(content.currentBattle) : <Skeleton width={150} />}
                            </Typography>
                        </div>
                    </div>
                </Paper>
            </Grid>
        </Grid>
    }

    renderMatchingUsers() {
        const users = this.state.content.matchingUsers || [];

        return <Paper style={{marginTop: 24}}>
            <CardHeader title="Live Players" subheader={`${users.length} user(s) matching or in battle`} />
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Status</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Queue</TableCell>
                        <TableCell>User ID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Web User ID</TableCell>
                        <TableCell>Wager</TableCell>
                        <TableCell>Mode</TableCell>
                        <TableCell>Joined</TableCell>
                        <TableCell>Internal Team</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.loading && <TableRow>
                        <TableCell colSpan={10}>
                            <Skeleton height={40} />
                        </TableCell>
                    </TableRow>}
                    {!this.state.loading && users.length === 0 && <TableRow>
                        <TableCell colSpan={10}>No users are matching or in battle.</TableCell>
                    </TableRow>}
                    {!this.state.loading && users.map((user: any, index: number) => <TableRow key={`${user.queue}-${user.userId}-${index}`}>
                        <TableCell>{user.status || "-"}</TableCell>
                        <TableCell>{user.battleType || "-"}</TableCell>
                        <TableCell>{user.queue}</TableCell>
                        <TableCell>{user.userId}</TableCell>
                        <TableCell>{user.name || "-"}</TableCell>
                        <TableCell>{user.webUserId || "-"}</TableCell>
                        <TableCell>{user.wager || "-"}</TableCell>
                        <TableCell>{user.mode || "-"}</TableCell>
                        <TableCell>{user.time ? new Date(user.time).toLocaleString() : "-"}</TableCell>
                        <TableCell>{user.isInternalTeam ? "Yes" : "No"}</TableCell>
                    </TableRow>)}
                </TableBody>
            </Table>
        </Paper>
    }

    render() {
        return <Paper className="contentPadding">
            <CardHeader title="Ruby Battle Summary" />
            {this.renderFilter()}
            {this.renderContent()}
            {this.renderMatchingUsers()}
        </Paper>
    }
}

const styles: any = theme => ({
    actions: {
        color: theme.palette.text.secondary,
        float: "right",
    },
    button: {
        margin: 8,
    },
});

export const RubyBattle = withStyles(styles)(RubyBattleWrapped);